export default __webpack_public_path__ + "static/media/heilsan.f2ebaabe.svg";